export const CONTENT = "This flight operates through multiple airlines.";
